var render = function render(){var _vm=this,_c=_vm._self._c;return _c('planejamento-contrato-form',{attrs:{"somente-leitura":_vm.somenteLeitura,"novo":_vm.novo,"edicao":_vm.edicao,"copia":_vm.copia,"alterar-finalizado":_vm.alterarFinalizado}})
}
var staticRenderFns = []

export { render, staticRenderFns }